<template>
  <figure
    :class="[
      'picture c-picture',
      isImg ? 'picure--img' : 'picture--div',
    ]"
    :data-anim="isLazy ? 'picture' : isLazy"
  >
    <img
      :data-src="isLazy ? data.url : isLazy"
      :alt="data.alt"
      :src="isLazy ? !isLazy : data.url"
    >
    <div
      class="picture__image-bg"
      :style="{
        backgroundImage: isLazy ? !isLazy : `url(${data.url})`,
      }"
    ></div>
  </figure>
</template>

<script>
export default {
  name: 'appPicture',

  props: {
    data: {
      type: Object,
      required: true,
    },

    isLazy: {
      type: Boolean,
      required: false,
      default: true,
    },

    isImg: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";
@import '../style/variables';
@import "../style/mixins";

.picture {
  position: relative;
  width: 100%;

  &__image-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  img {
    display: inline-block;
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
  }

  &:not(.picture--img) {
    img {
      @include visually-hidden;
    }
  }

  &:not(.picture--div) {
    .picture__image-bg {
      @include visually-hidden;
    }
  }
}
</style>
